import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const ExamApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['exam', 'get', webinarId], (api) => api.exam.get(webinarId), options),
    update: (options?: BaseApiMutationOptions<ApiClient['exam']['update']>) => apiMutationOptions((api) => api.exam.update, options)
};
